<template>
  <div class="main_view">
    <el-container>
      <!--导航栏-->
      <el-header>
        <div class="yy_head">
          <div class="yy_head_left">
            <div class="yy_head_logo">
              <a href="/#/" target="_blank">
                <img src="/static/images/bigdata/maoyan_logo.png"/>
              </a>
            </div>
            <div class="yy_head_line"></div>
            <el-button plain icon="el-icon-document-copy" size="small" style="border-width: 0; color:#409EFF;" @click="head_tab(0)">需求管理</el-button>
            <el-button plain icon="el-icon-document-checked" size="small" style="border-width: 0;" @click="head_tab(1)">招募管理</el-button>
            <el-button plain icon="el-icon-user" size="small" style="border-width: 0;" @click="head_tab(2)">账户管理</el-button>
          </div>
          <div class="yy_head_right">
            <div class="yy_head_btn"><el-button plain size="small" icon="el-icon-document-checked">可邀约 {{userData.re_yy_count}} 次</el-button></div>
            <!--            <div class="yy_head_btn"><el-button type="primary" icon="el-icon-success" size="small">已选 123 人</el-button></div>-->
            <div class="yy_head_user" @mouseover="logoutOver" @mouseout="logoutOut">
              <img class="yy_head_user_img" src="/static/images/bigdata/brand_head_icon.png"/>
              <div class="yy_head_user_nickname">{{userData.nickname}}</div>
              <div class="yy_head_user_logout" v-show="showLogin" @click="clickLogout">退 出 登 录</div>
            </div>
          </div>
        </div>
      </el-header>
      <!--内容栏-->
      <el-main>
        <!--需求栏-->
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       style="background-color: #FFFFFF; height: 40px; padding-left: 10px;
                       display: flex; align-items:center; margin-bottom: 10px; margin-top: 10px;">
          <el-breadcrumb-item :to="{ path: '/#/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/yyrequests' }">需求管理</el-breadcrumb-item>
          <el-breadcrumb-item >需求编辑</el-breadcrumb-item>
        </el-breadcrumb>
        <!--筛选栏-->
        <div class="yy_filter" style="background-color: #FFFFFF; padding-top: 20px; padding-bottom: 20px">
            <el-form ref="form" :model="form" label-width="80px">
              <el-form-item label="需求ID" v-if="form.pk !== ''">
                {{form.pk}}
              </el-form-item>

              <el-form-item label="*活动标题">
                <el-col :span="8">
                  <el-input v-model="form.campaign" placeholder="例如：品牌水杯招募小红书博主"></el-input>
                </el-col>
              </el-form-item>

              <el-form-item label="*产品名称">
                <el-col :span="8">
                  <el-input v-model="form.product" placeholder="例如：xxx高颜值水杯"></el-input>
                </el-col>
              </el-form-item>

              <el-form-item label="赠品信息">
                <el-col :span="8">
                  <el-input v-model="form.gift" placeholder="赠品名称和价值(可不填)"></el-input>
                </el-col>
              </el-form-item>

              <el-form-item label="探店地址">
                <el-col :span="8">
                  <el-input v-model="form.location" placeholder="详细探店地址(可不填)"></el-input>
                </el-col>
              </el-form-item>

              <el-form-item label="*创作类型">
                <el-radio-group v-model="form.c_type">
                  <el-radio label="全部" value="全部"></el-radio>
                  <el-radio label="视频" value="视频"></el-radio>
                  <el-radio label="图文" value="图文"></el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="*执行日期">
                <el-col :span="4">
                  <el-date-picker type="date" placeholder="开始日期" v-model="form.date_s" style="width: 100%;"></el-date-picker>
                </el-col>
                <el-col class="line" :span="1" style="width: 10px;">~</el-col>
                <el-col :span="4">
                  <el-date-picker type="date" placeholder="结束日期" v-model="form.date_e" style="width: 100%;"></el-date-picker>
                </el-col>
              </el-form-item>

              <el-form-item label="*报酬范围">
                <el-col :span="4">
                  <el-input v-model="form.reward_s" placeholder="最小报酬(元)"></el-input>
                </el-col>
                <el-col class="line" :span="1" style="width: 10px;">~</el-col>
                <el-col :span="4">
                  <el-input v-model="form.reward_e" placeholder="最大报酬(元)"></el-input>
                </el-col>
              </el-form-item>

              <el-form-item label="*博主平台">
                <el-checkbox-group v-model="form.platform">
                  <el-checkbox label="小红书" value="小红书"></el-checkbox>
                  <el-checkbox label="抖音" value="抖音"></el-checkbox>
                  <el-checkbox label="淘宝" value="淘宝"></el-checkbox>
                  <el-checkbox label="知乎" value="知乎"></el-checkbox>
                  <el-checkbox label="B站" value="B站"></el-checkbox>
                  <el-checkbox label="得物" value="得物"></el-checkbox>
                  <el-checkbox label="大众点评" value="大众点评"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>

              <el-form-item label="*博主性别">
                <el-radio-group v-model="form.gender">
                  <el-radio label="全部" value="全部"></el-radio>
                  <el-radio label="男" value="男"></el-radio>
                  <el-radio label="女" value="女"></el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item label="*博主粉丝">
                <el-col :span="4">
                  <el-input v-model="form.fans_s" placeholder="最小粉丝数"></el-input>
                </el-col>
                <el-col class="line" :span="1" style="width: 10px;">~</el-col>
                <el-col :span="4">
                  <el-input v-model="form.fans_e" placeholder="最大粉丝数"></el-input>
                </el-col>
              </el-form-item>

              <el-form-item label="*博主类目">
                <el-checkbox-group v-model="form.category" @change="categoryChange">
                  <el-checkbox label="全部" value="全部"></el-checkbox>
                  <el-checkbox label="美妆" value="美妆"></el-checkbox>
                  <el-checkbox label="护肤" value="护肤"></el-checkbox>
                  <el-checkbox label="个人护理" value="个人护理"></el-checkbox>
                  <el-checkbox label="母婴" value="母婴"></el-checkbox>
                  <el-checkbox label="时尚" value="时尚"></el-checkbox>
                  <el-checkbox label="美食" value="美食"></el-checkbox>
                  <el-checkbox label="家居家装" value="家居家装"></el-checkbox>
                  <el-checkbox label="影视综资讯" value="影视综资讯"></el-checkbox>
                  <el-checkbox label="运动健身" value="运动健身"></el-checkbox>
                  <el-checkbox label="宠物" value="宠物"></el-checkbox>
                  <el-checkbox label="文化艺术" value="文化艺术"></el-checkbox>
                  <el-checkbox label="兴趣爱好" value="兴趣爱好"></el-checkbox>
                  <el-checkbox label="生活记录" value="生活记录"></el-checkbox>
                  <el-checkbox label="教育" value="教育"></el-checkbox>
                  <el-checkbox label="职场" value="职场"></el-checkbox>
                  <el-checkbox label="情感" value="情感"></el-checkbox>
                  <el-checkbox label="摄影" value="摄影"></el-checkbox>
                  <el-checkbox label="游戏" value="游戏"></el-checkbox>
                  <el-checkbox label="科技数码" value="科技数码"></el-checkbox>
                  <el-checkbox label="出行旅游" value="出行旅游"></el-checkbox>
                  <el-checkbox label="音乐" value="音乐"></el-checkbox>
                  <el-checkbox label="搞笑" value="搞笑"></el-checkbox>
                  <el-checkbox label="健康养生" value="健康养生"></el-checkbox>
                  <el-checkbox label="汽车" value="汽车"></el-checkbox>
                  <el-checkbox label="婚嫁" value="婚嫁"></el-checkbox>
                  <el-checkbox label="商业财经" value="商业财经"></el-checkbox>
                  <el-checkbox label="素材" value="素材"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="博主地域">
                <el-checkbox-group v-model="form.p_location"  @change="p_locationChange">
                  <el-checkbox label="全部" value="全部"></el-checkbox>
                  <el-checkbox label="河北" value="河北"></el-checkbox>
                  <el-checkbox label="山西" value="山西"></el-checkbox>
                  <el-checkbox label="辽宁" value="辽宁"></el-checkbox>
                  <el-checkbox label="吉林" value="吉林"></el-checkbox>
                  <el-checkbox label="黑龙江" value="黑龙江"></el-checkbox>
                  <el-checkbox label="江苏" value="江苏"></el-checkbox>
                  <el-checkbox label="浙江" value="浙江"></el-checkbox>
                  <el-checkbox label="福建" value="福建"></el-checkbox>
                  <el-checkbox label="江西" value="江西"></el-checkbox>
                  <el-checkbox label="山东" value="山东"></el-checkbox>
                  <el-checkbox label="河南" value="河南"></el-checkbox>
                  <el-checkbox label="湖北" value="湖北"></el-checkbox>
                  <el-checkbox label="湖南" value="湖南"></el-checkbox>
                  <el-checkbox label="广东" value="广东"></el-checkbox>
                  <el-checkbox label="海南" value="海南"></el-checkbox>
                  <el-checkbox label="四川" value="四川"></el-checkbox>
                  <el-checkbox label="贵州" value="贵州"></el-checkbox>
                  <el-checkbox label="云南" value="云南"></el-checkbox>
                  <el-checkbox label="陕西" value="陕西"></el-checkbox>
                  <el-checkbox label="甘肃" value="甘肃"></el-checkbox>
                  <el-checkbox label="青海" value="青海"></el-checkbox>
                  <el-checkbox label="台湾" value="台湾"></el-checkbox>
                  <el-checkbox label="内蒙古" value="内蒙古"></el-checkbox>
                  <el-checkbox label="西藏" value="西藏"></el-checkbox>
                  <el-checkbox label="宁夏" value="宁夏"></el-checkbox>
                  <el-checkbox label="新疆" value="新疆"></el-checkbox>
                  <el-checkbox label="北京" value="北京"></el-checkbox>
                  <el-checkbox label="天津" value="天津"></el-checkbox>
                  <el-checkbox label="上海" value="上海"></el-checkbox>
                  <el-checkbox label="重庆" value="重庆"></el-checkbox>
                  <el-checkbox label="香港" value="香港"></el-checkbox>
                  <el-checkbox label="澳门" value="澳门"></el-checkbox>
                  <el-checkbox label="美国" value="美国"></el-checkbox>
                  <el-checkbox label="日本" value="日本"></el-checkbox>
                  <el-checkbox label="澳大利亚" value="澳大利亚"></el-checkbox>
                  <el-checkbox label="加拿大" value="加拿大"></el-checkbox>
                  <el-checkbox label="韩国" value="韩国"></el-checkbox>
                  <el-checkbox label="法国" value="法国"></el-checkbox>
                  <el-checkbox label="德国" value="德国"></el-checkbox>
                  <el-checkbox label="新加坡" value="新加坡"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="博主身份">
                <el-checkbox-group v-model="form.p_type"   @change="p_typeChange">
                  <el-checkbox label="全部" value="全部"></el-checkbox>
                  <el-checkbox label="摄影师" value="摄影师"></el-checkbox>
                  <el-checkbox label="插画师" value="插画师"></el-checkbox>
                  <el-checkbox label="室内设计师" value="室内设计师"></el-checkbox>
                  <el-checkbox label="画家" value="画家"></el-checkbox>
                  <el-checkbox label="平面设计师" value="平面设计师"></el-checkbox>
                  <el-checkbox label="服装设计师" value="服装设计师"></el-checkbox>
                  <el-checkbox label="建筑设计师" value="建筑设计师"></el-checkbox>
                  <el-checkbox label="珠宝设计师" value="珠宝设计师"></el-checkbox>
                  <el-checkbox label="涂鸦艺术家" value="涂鸦艺术家"></el-checkbox>
                  <el-checkbox label="数字艺术家" value="数字艺术家"></el-checkbox>
                  <el-checkbox label="学生" value="学生"></el-checkbox>
                  <el-checkbox label="编辑" value="编辑"></el-checkbox>
                  <el-checkbox label="翻译" value="翻译"></el-checkbox>
                  <el-checkbox label="作家" value="作家"></el-checkbox>
                  <el-checkbox label="记者" value="记者"></el-checkbox>
                  <el-checkbox label="非遗传承人" value="非遗传承人"></el-checkbox>
                  <el-checkbox label="舞蹈老师" value="舞蹈老师"></el-checkbox>
                  <el-checkbox label="模特" value="模特"></el-checkbox>
                  <el-checkbox label="化妆师" value="化妆师"></el-checkbox>
                  <el-checkbox label="造型师" value="造型师"></el-checkbox>
                  <el-checkbox label="主播" value="主播"></el-checkbox>
                  <el-checkbox label="主持人" value="主持人"></el-checkbox>
                  <el-checkbox label="导演" value="导演"></el-checkbox>
                  <el-checkbox label="娱评人" value="娱评人"></el-checkbox>
                  <el-checkbox label="影评人" value="影评人"></el-checkbox>
                  <el-checkbox label="制片人" value="制片人"></el-checkbox>
                  <el-checkbox label="编剧" value="编剧"></el-checkbox>
                  <el-checkbox label="乐评人" value="乐评人"></el-checkbox>
                  <el-checkbox label="经纪人" value="经纪人"></el-checkbox>
                  <el-checkbox label="创业者" value="创业者"></el-checkbox>
                  <el-checkbox label="营养师" value="营养师"></el-checkbox>
                  <el-checkbox label="金融从业者" value="金融从业者"></el-checkbox>
                  <el-checkbox label="甜点师" value="甜点师"></el-checkbox>
                  <el-checkbox label="教练" value="教练"></el-checkbox>
                  <el-checkbox label="厨师" value="厨师"></el-checkbox>
                  <el-checkbox label="品牌创始人" value="品牌创始人"></el-checkbox>
                  <el-checkbox label="医生" value="医生"></el-checkbox>
                  <el-checkbox label="空乘" value="空乘"></el-checkbox>
                  <el-checkbox label="运营" value="运营"></el-checkbox>
                  <el-checkbox label="产品经理" value="产品经理"></el-checkbox>
                  <el-checkbox label="运动员" value="运动员"></el-checkbox>
                  <el-checkbox label="咖啡师" value="咖啡师"></el-checkbox>
                  <el-checkbox label="花艺师" value="花艺师"></el-checkbox>
                  <el-checkbox label="调酒师" value="调酒师"></el-checkbox>
                  <el-checkbox label="工程师" value="工程师"></el-checkbox>
                  <el-checkbox label="整理师" value="整理师"></el-checkbox>
                  <el-checkbox label="程序员" value="程序员"></el-checkbox>
                  <el-checkbox label="销售" value="销售"></el-checkbox>
                  <el-checkbox label="民宿主" value="民宿主"></el-checkbox>
                  <el-checkbox label="HR" value="HR"></el-checkbox>
                  <el-checkbox label="公益人" value="公益人"></el-checkbox>
                  <el-checkbox label="发型设计师" value="发型设计师"></el-checkbox>
                  <el-checkbox label="育婴师" value="育婴师"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="详情要求">
                <el-col :span="8">
                  <el-input type="textarea" v-model="form.detail_r" :autosize="{ minRows: 4, maxRows: 8}" placeholder="例如：需要博主做什么？什么时候结款等（可不填）"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="*PR微信号">
                <el-col :span="8">
                  <el-input v-model="form.pr_wechat" placeholder="例如：15212345678（博主如何联系你）"></el-input>
                </el-col>
              </el-form-item>
              <el-form-item label="*邀约数量">
                <el-col :span="8">
                  <el-input-number v-model="form.yy_num" :min="10" :max="1000"></el-input-number>
                </el-col>
              </el-form-item>
              <el-form-item>
                <div class="yy_filter_btn">
                  <el-button @click="onSubmit('save')">保存需求</el-button>
                  <el-button type="primary" @click="onAction()">发起邀约</el-button>
                </div>
              </el-form-item>
            </el-form>
        </div>
      </el-main>
      <!--底部导航-->
      <el-footer>
        <div class="yy_bottom">COPYRIGHT  2020-2024 杭州袤周云计算有限公司<a rel="nofollow" href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2022031665号</a></div>
      </el-footer>
    </el-container>
  </div>
</template>


<script>
import moment from "moment";
import {Base64} from 'js-base64';
import process from "shelljs";
export default {
  name: "YYRequestEdit",
  data() {
    return {
      showLogin: false,
      userData: '',
      form: {
        pk: '',
        campaign: '',
        product: '',
        gift: '',
        c_type: '',
        date_s: '',
        date_e: '',
        reward_s: '',
        reward_e: '',
        platform: [],
        gender: '',
        fans_s: '',
        fans_e: '',
        category: [],
        pr_wechat: '',
        detail_r: '',
        location: '',
        p_location: [],
        p_type: [],
        yy_num: 100,
        yy_action: '',
        sign: '',
      },
    }
  },
  methods: {
    clickLogout () {
      // 本地保存token
      this.$cookies.remove("UserToken");
      this.$cookies.remove("UserName");
      // 跳转
      this.$router.push('/yylogin');
    },
    logoutOver () {
      this.showLogin = true;
    },
    logoutOut () {
      this.showLogin = false;
    },
    head_tab(val) {
      // if(val===0){
      //   this.$router.push({path: '/yyrequests'});
      // }
      if(val===1){
        this.$router.push({path: '/yyzhaomus'});
      }
      if(val===2){
        this.$router.push({path: '/yyaccounts'});
      }
    },
    categoryChange(val){
      for (let i=0; i<val.length; i++) {
        if(val[i] === '全部'){
          this.form.category = ['全部'];
          return;
        }
      }
    },
    p_locationChange(val){
      for (let i=0; i<val.length; i++) {
        if(val[i] === '全部'){
          this.form.p_location = ['全部'];
          return;
        }
      }
    },
    p_typeChange(val){
      for (let i=0; i<val.length; i++) {
        if(val[i] === '全部'){
          this.form.p_type = ['全部'];
          return;
        }
      }
    },
    getListData() {
      let sendTime = moment(new Date()).format("YYYYMMDDHHssmm");
      let sign = Base64.encode('Maozhou2024' + sendTime);
      let base = '/api';
      if (process.env.NODE_ENV === "development") {
        base = 'http://api.wushangxianzhi.com';
      }
      let url = '/api/v2/maoyy/yy_requests_detail';
      this.$axios.defaults.headers.common['Authorization'] = this.$cookies.get('UserToken')
      this.$axios({
        method: 'post',
        url: `${base}${url}`,
        responseType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          'sign': sign,
          'request_id': this.form.pk,
        })
      }).then((res) => {
        console.log("res ", res);
        let data = res.data;
        if (data.error === 0) {
          this.form = data.result[0];
        } else {
          this.$message({
            showClose: true,
            message: data.message,
            type: 'error'
          });
        }
      }).catch((res) => {
        console.log("res ", res);
        this.$message({
          showClose: true,
          message: res,
          type: 'error'
        });
      })
    },
    getUserData() {
      let sendTime = moment(new Date()).format("YYYYMMDDHHssmm");
      let sign = Base64.encode('Maozhou2024' + sendTime);
      let base = '/api';
      if (process.env.NODE_ENV === "development") {
        base = 'http://api.wushangxianzhi.com';
      }
      let url = '/api/v2/maoyy/yy_user_detail';
      this.$axios.defaults.headers.common['Authorization'] = this.$cookies.get('UserToken')
      this.$axios({
        method: 'post',
        url: `${base}${url}`,
        responseType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          'sign': sign,
        })
      }).then((res) => {
        console.log("success:", res);
        let data = res.data;
        if (data.error === 0) {
          this.userData = data.result[0];
        } else {
          this.$message({
            showClose: true,
            offset: 100,
            message: data.message,
            type: 'error'
          });
        }
      }).catch((res) => {
        console.log("error:", res);
        this.$message({
          showClose: true,
          offset: 100,
          message: res,
          type: 'error'
        });
      })
    },
    onAction(){
      let msg = '此操作将消耗【'+this.form.yy_num+'】邀约次数, 是否继续?'
      this.$confirm(msg, '操作提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.onSubmit('action');
      }).catch(() => {
      });
    },
    onSubmit(val) {
      let sendTime = moment(new Date()).format("YYYYMMDDHHssmm");
      this.form.sign = Base64.encode('Maozhou2024' + sendTime);
      this.form.yy_action = val;
      let base = '/api';
      if (process.env.NODE_ENV === "development") {
        base = 'http://api.wushangxianzhi.com';
      }
      let url = '/api/v2/maoyy/yy_requests_create';
      this.$axios.defaults.headers.common['Authorization'] = this.$cookies.get('UserToken')
      this.$axios({
        method: 'post',
        url: `${base}${url}`,
        responseType: 'json',
        contentType: 'application/json',
        data: this.form,
      }).then((res) => {
        console.log("res ", res);
        let data = res.data;
        if (data.error === 0) {
          if(val==='save'){
            this.$alert('需求保存成功', '操作提示', {
              confirmButtonText: '确定',
              callback: action => {}
            });
          } else {
            this.$alert('邀约创建成功', '操作提示', {
              confirmButtonText: '确定',
              callback: action => {}
            });
          }
        } else {
          this.$message({
            showClose: true,
            message: data.message,
            type: 'error'
          });
        }
      }).catch((res) => {
        console.log("res ", res);
        this.$message({
          showClose: true,
          message: res,
          type: 'error'
        });
      })
    }
  },
  mounted () {
    if (this.$cookies.get('UserToken')) {
      this.getUserData();
      // 加载数据
      this.form.pk = this.$route.query.request_id;
      if (this.form.pk !== '') {
        this.getListData();
      }
    } else {
      console.dir('退出登录');
      this.clickLogout ();
    }
    // // 判断页面是否在手机端打开
    // let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    // if (flag!=null) {
    //   console.log('当前在手机端');
    //   this.showTitle = false;
    // } else {
    //   console.log('当前在PC端');
    //   this.showTitle = true;
    // }
  },
  metaInfo: {
    title: "袤周-AI智能找“人”工具",
    meta: [
      { name: "viewport", content: "width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0" },
      { name: "keywords", content: "袤周-大数据驱动下的智慧种草平台" },
      { name: "description", content: "袤周-大数据驱动下的智慧种草平台" },
      { name: "format-detection", content: "telephone=no,email=no" }
    ],
    link: [{
      rel: 'shortcut icon',
      href: '/static/favicon.ico'
    }]
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '../comm/css/base.styl'
.main_view
  width 100%
  background-color #f5f7fc
  .el-header
    padding 0
    top 0
    position sticky
    z-index 10
    background-color $white
    .yy_head
      background-color $white
      box-shadow 0 1px 8px 0 rgba(0,0,0,0.1)
      width 100%
      display flex
      .yy_head_left
        padding-left 12%
        display flex
        flex-direction row
        .yy_head_logo
          height 60px
          img
            height 50px
            padding-top 5px
        .yy_head_line
          margin-left 10px
          width 1px
          height 60px
          background-color $colorE

      .yy_head_right
        height 60px
        width auto
        margin-left auto
        padding-right 12%
        display flex
        flex-direction row
        .yy_head_btn
          display flex
          align-items center
          margin-right 10px
        .yy_head_user
          display flex
          flex-direction row
          height 60px
          .yy_head_user_img
            margin-top 10px
            margin-left 10px
            height 40px
            width 40px
            border-radius 60px
          .yy_head_user_nickname
            color #000000
            font-size 14px
            margin-left 10px
            display flex
            align-items center
          .yy_head_user_logout
            margin-right 12%
            position absolute
            width 120px
            height 38px
            display flex
            flex-direction column
            align-items center
            justify-content center
            color $white
            cursor pointer
            z-index 1
            right 0
            top 60px
            font-size 14px
            background $grey



  .el-container
    padding 0

  .el-main
    padding 0
    padding-left 12%
    padding-right 12%
    .yy_filter
      .el-form
        padding 0
        .yy_filter_btn
          margin-right 80px
          display flex
          justify-content center


  .el-footer
    padding 0
    margin-top 20px
    bottom 0
    left 0
    width 100%
    .yy_bottom
      background linear-gradient(135deg, rgba(51,51,51,1) 0%, rgba(17,17,17,1) 100%)
      height auto
      display flex
      flex-direction row
      color $white
      justify-content center
      align-items center
      a
        margin-left: 10px
        margin-top 20px
        margin-bottom 20px
        color $white
</style>




// WEBPACK FOOTER //
// src/components/yaoyue/YYRequestEdit.vue